import { LocalizedSectionTitle, FieldsContainer } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { CompanyAdditionalInfoFields } from './CompanyAdditionalInfoFields';
import { CompanyPaymentFields } from './CompanyPaymentFields';

const AdditionalInfoFields = () => (
    <FieldsContainer>
        <CompanyAdditionalInfoFields />
        <LocalizedSectionTitle textKey={TextKey.Payment} />
        <CompanyPaymentFields />
    </FieldsContainer>
);

export default AdditionalInfoFields;
